<template>
    <div class="card box-shadow" v-if="resource_list">
        <div class="card-header" v-if="showResource">
            <h4 class="my-0 font-weight-normal">{{ documentTitle }} ({{ docType }})</h4>

            <button v-on:click="browseResourcesLeft">
                <b-icon icon="arrow-left" font-scale="1"></b-icon>
            </button>
            {{ this.resource_index + 1 }} / {{ resource_list.length }}
            <button v-on:click="browseResourcesRight">
                <b-icon icon="arrow-right" font-scale="1"></b-icon>
            </button>
        </div>

        <div class="card-body" v-if="showResource">
            <div class="container" v-if="checkDocumentType == 'img'">
                <div>
                    <b-button v-b-modal="'myModal' + modalId" size="sm" variant="outline-primary">Show document</b-button>
                    <a target="_blank" :href="`${resource_list[this.resource_index]}`">
                        &nbsp; open directly <b-icon icon="cloud-arrow-down" font-scale="1.5"></b-icon
                    ></a>

                    <b-modal size="lg" v-bind:id="'myModal' + modalId">
                        <p class="my-4">
                            <img class="card-img-top img-thumbnail" :src="`${resource_list[this.resource_index]}`" />
                        </p>
                    </b-modal>
                </div>
                <img class="card-img-top img-thumbnail" :src="`${resource_list[this.resource_index]}`" />
            </div>
            <div class="container" v-else>
                <div>
                    <b-button v-b-modal="'myModal' + modalId" size="sm" variant="outline-primary">Show document</b-button>
                    <a target="_blank" :href="`${resource_list[this.resource_index]}`">
                        <b-icon icon="cloud-arrow-down" font-scale="1.5"></b-icon>&nbsp; open directly</a
                    >
                    <b-modal size="lg" v-bind:id="'myModal' + modalId" v-if="resource_list.length > 0">
                        <div id="pdfvuer-modal" class="text-center">
                            <pdf
                                :src="`${resource_list[this.resource_index]}`"
                                :page="1"
                                :style.sync="style_modal"
                                style="width: 100%; margin: 20px auto"
                                :annotation="true"
                                :resize.sync="resize_modal"
                                @link-clicked="handle_pdf_link"
                            >
                                <template slot="loading"> loading content here... </template>
                            </pdf>
                        </div>
                    </b-modal>
                </div>
                <div id="pdfvuer-grid" v-if="resource_list.length > 0" class="text-center">
                    <pdf
                        :src="`${resource_list[this.resource_index]}`"
                        :page="1"
                        style="width: 66%; margin: 20px auto"
                        :annotation="true"
                        @link-clicked="handle_pdf_link"
                    >
                        <template slot="loading"> loading content here... </template>
                    </pdf>
                </div>
            </div>
        </div>
        <div class="card-body" v-else>
            <div class="container">
                <div v-if="resource_list.length > 0">
                    Cannot show provided document in app (e.g. stored in wrike or salesforce ehich is not supported). Please
                    download the resource manually and review it separately in new browser tab.
                </div>
                <div v-else>No resources uploaded or available</div>
                <div class="mt-xl-4" />

                <a target="_blank" v-if="resource_list.length > 0" :href="`${resource_list[this.resource_index]}`">
                    <b-icon icon="cloud-arrow-down" font-scale="3">open</b-icon>&nbsp; open directly</a
                >
            </div>
        </div>
    </div>
    <div v-else>loading...</div>
</template>

<script>
import pdf from "pdfvuer";

export default {
    name: "DocumentViewer",
    components: { pdf },
    props: {
        documentTitle: { type: String },
        docType: { type: String },
        getResources: { type: Function },
        modalId: { type: String }
    },
    data() {
        return {
            scale: "page-width",
            style_modal: "width: 100%; margin: 20px auto",
            style_grid: "width: 30%; margin: 20px auto",
            resize_grid: true,
            resize_modal: false,
            myDocType: this.docType,
            resources: this.getResources(),
            showDocument: true,
            resource_index: 0,
            isFetching: true
        };
    },
    computed: {
        checkDocumentType: function () {
            const imageTypes = ["png", "jpg", "jpeg", "gif", "jfif"];

            if (this.resources.length > 0) {
                const ext = this.resources[this.resource_index].split(".").pop();
                const docServer = this.resources[this.resource_index].indexOf("https://vppp-docs.vpp-prep.sonnen.de") == 0;
                console.log("docServer", docServer);
                if (imageTypes.includes(ext.toLowerCase()) || docServer === true) {
                    return "img";
                } else {
                    return ext;
                }
            }
            return false;
        },

        resource_list: function () {
            return this.resources;
        },
        showResource: function () {
            try {
                if (this.resource_list[this.resource_index].indexOf("wrike") > -1) {
                    return false;
                }
                return true;
            } catch (error) {
                return false;
            }
        }
    },
    created() {},
    watch: {
        show: function (s) {
            console.log(s);
        },
        page: function (p) {
            if (
                window.pageYOffset <= this.findPos(document.getElementById(p)) ||
                (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
            ) {
                // window.scrollTo(0,this.findPos(document.getElementById(p)));
                document.getElementById(p).scrollIntoView();
            }
        }
    },

    mounted() {
        console.log("DocumentViewer mounted.");
    },
    methods: {
        handle_pdf_link: function (params) {
            var page = document.getElementById(String(params.pageNumber));
            page.scrollIntoView();
        },

        browseResourcesLeft: function () {
            this.resource_index -= 1;
            if (this.resource_index > this.resource_list.length - 1) {
                this.resource_index = 0;
            }
            if (this.resource_index < 0) {
                this.resource_index = this.resource_list.length - 1;
            }
        },
        browseResourcesRight: function () {
            this.resource_index += 1;
            if (this.resource_index > this.resource_list.length - 1) {
                this.resource_index = 0;
            }
            if (this.resource_index < 0) {
                this.resource_index = this.resource_list.length - 1;
            }
        }
    }
};
</script>
<style src="pdfvuer/dist/pdfvuer.css"></style>
